import http from "./http";

export const fetchAdmins = () => http.get("/accounts/view");
export const fetchRoles = () => http.get("/accounts/roles");
export const fetchPermissions = () => http.get("/accounts/permissions");
export const executeCreateRole = (credentials) => {
  return http.post("/accounts/roles/add", credentials) 
}

export const executeUpdateRole = (id, payload) => {
    return http.patch(`/accounts/roles/${id}/update`, payload) 
}
// export const fetchSingleAdmin = (id) => http.get(`/partners/${id}`)

export const executeCreatePermission = (credentials) => {
    return http.post("/accounts/permissions/add", credentials)
}

export const executeUpdatePermission = (id, payload) => {
    return http.patch(`/accounts/permissions/${id}/update`, payload) 
}

export const executeCreateAdmin = (credentials) => {
  return http.post("/accounts/create", credentials) 
}

export const executeUpdateAdmin = (id, payload) => {
  return http.patch(`/accounts/${id}/update`, payload) 
}